import * as yup from 'yup'

export const loginValidationSchema = yup.object().shape({
  email: yup
    .string()
    .email('Masukan email dengan benar')
    .matches(/^(?!.*@[^,]*,)/)
    .required(),
  password: yup.string().min(8,'Password minimal 8 karakter').required("Masukan password")
})
